// Run cost is OpenCost-derived and gated behind SI-14411 ("drop cost
// block"); off by default (Backstage flags start inactive), opt in via
// Settings → Feature Flags to surface the Run cost card + headline tile.
export const SHOW_OPENCOST_FLAG = 'spog-show-opencost';
